export const environment = {
    REACT_APP_MOD: import.meta.env.REACT_APP_MOD,
    isDevelopment : import.meta.env.REACT_APP_MOD == 'development',
    localRestUrl : 'http://rest.onro.org'
}
